module.exports = __webpack_public_path__ + "public/img/cnt-top-r.4ce1e7cb.png";